import React, { useEffect, useContext, useState } from "react";
import Grid from "@mui/material/Grid2";


export default function Hero() {


  return (
    <section>
    <Grid container size={12} className="hero-section">
      <Grid
        size={{ xs: 12, sm: 10, md: 12, lg: 12 }}
        container
        className="hero-tagline"
      >
        <h1 >Your Community, Your Voice, Our Focus</h1>
      </Grid>
  
    </Grid>
  </section>
  );
}
